import React from 'react';
import '../../style/articleModal.css'
import Button from "../button";
import GeneralSVG from "../generalSVG";

const ArticleModal = (props) => {
    return (
        <div className="col-sm-12">
            <div className="row">
                <div className="col-sm-12">
                    <span className="articleModal-title">
                        {props.article.title}
                    </span>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12" dangerouslySetInnerHTML={{__html: props.article.body}}>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    {
                        props.article.attatchmentDtos.length > 0 ?

                            <ul className="solicitorArticlesList-modal-attachments-ul">
                                {
                                    props.article.attatchmentDtos.map((attachment, index) => {
                                        return <li key={index}>
                                            <a onClick={() => props.requestGetArticleAttachment({articleId:props.article.id,attachmentId:attachment.id})}
                                               className="applicationPolicy-document-tab-link">
                                                <GeneralSVG
                                                    SvgWrapper="generalTab-download-wrapper inlineBlock"
                                                    Label="Download"
                                                    Svg={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
                                                        <title>Asset 9</title>
                                                        <g id="Layer_2" data-name="Layer 2">
                                                            <g id="info">
                                                                <path
                                                                    d="M9.5,6a.5.5,0,0,0-.5.5V9H1V6.5a.5.5,0,0,0-1,0V10H10V6.5A.5.5,0,0,0,9.5,6Z"/>
                                                                <path
                                                                    d="M5,7.21,7.35,4.85a.5.5,0,0,0-.71-.71L5.5,5.29V0h-1V5.29L3.35,4.15a.5.5,0,0,0-.71.71Z"/>
                                                            </g>
                                                        </g>
                                                    </svg>}
                                                />
                                            </a>
                                            {' '}
                                            {attachment.name}
                                        </li>
                                    })

                                }
                            </ul>

                            :
                            null
                    }
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <hr className="appFormRefSettings-hr"/>
                </div>
            </div>
            <Button
                wrapper={"btn-wrapper"}
                clickHandler={() => {
                    props.changeSolicitorArticlesListSettings('articleInModal', {});
                    props.changeSolicitorArticlesListSettings('openModal', false)
                }}
                btnType="button"
                btnStyle={'btn btn-primary btn-xs sharp white'}
                label="Back To Articles"
            />
        </div>
    )
};

export default ArticleModal;